import { addProp } from "@pnp/odata";
import { _Item } from "../items/types.js";
import { ContentType } from "./types.js";
addProp(_Item, "contentType", ContentType, "ContentType");
//# sourceMappingURL=item.js.map